module.exports = __webpack_public_path__ + "assets/img/58@3x.fa2a37fb.png";